import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, isCoach } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import Account from "@/pages/Account";
import PaymentResult from "@/pages/PaymentResult";
import Dashboard from "@/pages/coach/Dashboard";
import Clients from "@/pages/coach/Clients";
import ClientDetail from "@/pages/coach/ClientDetail";
import Library from "@/pages/coach/Library";
import Templates from "@/pages/coach/Templates";
import PlanPage from "@/pages/coach/PlanPage";
import AIStudio from "@/pages/coach/AIStudio";
import Billing from "@/pages/coach/Billing";
import Settings from "@/pages/coach/Settings";
import ClientHome from "@/pages/client/Home";
import MyPlans from "@/pages/client/MyPlans";
import Logs from "@/pages/client/Logs";
import CheckIn from "@/pages/client/CheckIn";
import Progress from "@/pages/client/Progress";
import MyBilling from "@/pages/client/MyBilling";

function Loading() {
  return <div className="min-h-screen grid place-items-center eyebrow" data-testid="app-loading">Loading K-FitHUB…</div>;
}

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "coach" && !isCoach(user)) return <Navigate to="/app" replace />;
  if (role === "client" && user.role !== "client") return <Navigate to="/coach" replace />;
  return <AppShell>{children}</AppShell>;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isCoach(user) ? "/coach" : "/app"} replace />;
}

const coach = [
  ["/coach", Dashboard], ["/coach/clients", Clients],
  ["/coach/clients/:id", ClientDetail], ["/coach/templates", Templates], ["/coach/library", Library], ["/coach/plans/:id", PlanPage],
  ["/coach/ai", AIStudio], ["/coach/billing", Billing], ["/coach/settings", Settings], ["/coach/account", Account],
];
const client = [
  ["/app", ClientHome], ["/app/plans", MyPlans], ["/app/logs", Logs], ["/app/checkin", CheckIn],
  ["/app/progress", Progress], ["/app/billing", MyBilling], ["/app/account", Account], ["/payment/result", PaymentResult],
];

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/set-password" element={<SetPassword />} />
            {coach.map(([p, C]) => <Route key={p} path={p} element={<Guard role="coach"><C /></Guard>} />)}
            {client.map(([p, C]) => <Route key={p} path={p} element={<Guard role="client"><C /></Guard>} />)}
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
